import { useSearchParams } from 'react-router-dom';

import { ReducedSignupStepProps } from 'containers/SignUp/Content/content.types';

import { useGetSelectedItem } from 'hooks/useGetSelectedItem';
import useSubmitOrchestrateForm from 'hooks/useSubmitOrchestrateForm';

import { Initial, UploadImages } from './components';

const KnowledgeAboutGLP: React.FC<ReducedSignupStepProps> = ({ moveToStep }) => {
  const { send, isLoading } = useSubmitOrchestrateForm();
  const { value, setValue } = useGetSelectedItem('knowledge_about_glp');
  const [params, setParams] = useSearchParams();

  const step = params.get('s') ?? '';

  const handleSelect = (v: string) => {
    if (v) {
      setValue(v);
      send('mif_qa', [{ answer: v, question: 'knowledge_about_glp' }], () => {
        if (v === 'currently_taking' && false) {
          // && false, because functionality is not ready yet
          return setParams((prev) => {
            prev.set('s', 'image_upload');
            return prev;
          });
        } else {
          moveToStep('next');
        }
      });
    }
  };

  return (
    <div className="onboarding-page-wrapper">
      {!step && (
        <Initial loading={isLoading} value={value as string | undefined} onSelect={handleSelect} />
      )}
      {step === 'image_upload' && <UploadImages />}
    </div>
  );
};

export default KnowledgeAboutGLP;
